import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import { Lazyload } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true,
  listenEvents: ['scroll']
});
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);

import axios from 'axios'
Vue.prototype.$axios = axios

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)

import mui from './assets/mui.js'
Vue.prototype.mui = mui
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('popstate', function (e) {
  router.isBack = true
}, false)